<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/casa-ferreirinha')">Casa Ferreirinha
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/howards-folly')">Howard’s Folly
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/prats-and-symington')">Prats and
                        Symington (Chryseia)
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-crasto')">Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vale-meao')">Quinta Do Vale
                        Meao
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vallado')">Quinta Do Vallado
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vesuvio')">Quinta Do Vesuvio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/roquette-cazes-quinta')">Roquette
                        &amp; Cazes — Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/portugal/douro-valley/symington')">Symington
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Symington</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Il porto ha sempre giocato un ruolo secondario rispetto ai vini investibili, con i collezionisti che preferiscono il Bordeaux
                        e Borgogna su qualsiasi offerta dalla Valle del Douro. Ma quando si tratta di sapore complesso e
                        longevità redditizia, uno dei pesi massimi più pesanti nel commercio del vino di Porto sono i Symington
                        Proprietà di famiglia. Ed è tutto grazie a una persona: lo scozzese James Symington che è arrivato
                        Il Portogallo nel 1882 a soli 19 anni con il sogno di diventare grande nel settore del vino. Uno fortuito
                        matrimonio con un'ereditiera del vino Porto, e il resto è storia.
                    </div>

                    <div class="howto-title2">Una tenuta a conduzione familiare da oltre un secolo</div>
                    <div class="howto-text">
                        La famiglia Symington è una leggenda vivente a Port. Proprietaria di marchi illustri come Dow, Graham, Warre, Smith Woodhouse, Quarles Harris e Quinta do Vesuvio, l'azienda di famiglia è responsabile di oltre il 25% di tutti i vini Porto esportati in tutto il mondo (con solo il 4% venduto nel Regno Unito).
                        Oggi, undici Symington (e tre generazioni) sono coinvolti nella gestione quotidiana del
                        tenuta, dal marketing (Paul) alle vendite (Johnny) alla vinificazione vera e propria (Peter e Charles). In
                        infatti, così famoso è Peter Symington (il membro più anziano del clan con 42 impressionanti vinificazioni
                        anni al suo attivo) che è stato votato "Enologo fortificato dell'anno" all'International
                        Wine Challenge a Londra non meno di sei volte. Sotto il suo timone, le tenute di Symington hanno
                        ha prodotto alcuni vini meravigliosi, in particolare Dow 2011, 2007, 1966, 1908, Warre Otima Tawny, LBV 1992,
                        1963, Graham 2000, 1970 e Smith Woodhouse 1977. La migliore annata di sempre sarebbe stata la 1960, la
                        ultima grande annata vinicola per il Porto. Questi sono vini d'investimento blue chip, ad esempio il Dow 2011
                        quasi raddoppiando il prezzo dopo aver ricevuto punteggi molto alti dalla critica. La loro Quinta do Noval
                        Il Nacional è stato a lungo un vino da investimento, raggiungendo facilmente le 1000 sterline a bottiglia.
                    </div>

                    <div class="howto-title2">Vent'anni di vini da tavola</div>
                    <div class="howto-text">
                        Tuttavia, con le vendite di vino Porto in calo, la famiglia Symington ha dovuto cercare altrove
                        per espansione. Entra in Chryseia, un vino da tavola rosso creato con l'ex proprietario di Cos D'Estournel Bruno
                        Prati. Il successo di Chryseia e del suo secondo vino gemello Post Scriptum ha galvanizzato il
                        La fiducia di Symington nella produzione di vino da tavola e nel 2018 sono stati annunciati piani per una cantina da 5 milioni di euro.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Symington</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Portwein spielte seit jeher eine untergeordnete Rolle gegenüber investierbaren Weinen, und Sammler bevorzugen Bordeaux
                        und Burgund über allen Angeboten aus dem Douro-Tal. Aber wenn es um komplexen Geschmack geht und
                        Mit einer guten Lagerfähigkeit ist der Symington eines der schwersten Schwergewichte im Portweinhandel
                        Familiengüter. Und das alles ist einer Person zu verdanken – dem Schotten James Symington, der dorthin gesegelt ist
                        Portugal im Jahr 1882, mit nur 19 Jahren, mit dem Traum, im Weingeschäft groß rauszukommen. Ein Zufall
                        Heirat mit einer Portwein-Erbin später, und der Rest ist Geschichte.
                    </div>

                    <div class="howto-title2">Ein familiengeführtes Anwesen seit über einem Jahrhundert</div>
                    <div class="howto-text">
                        Die Familie Symington ist eine lebende Legende in Port. Als Besitzer berühmter Marken wie Dow, Graham, Warre, Smith Woodhouse, Quarles Harris und Quinta do Vesuvio ist das Familienunternehmen für über 25 % aller exportierten Portweine weltweit verantwortlich (wobei nur 4 % im Vereinigten Königreich verkauft werden).
                        Heute sind elf Symingtons (und drei Generationen) an der täglichen Leitung des Unternehmens beteiligt
                        vom Marketing (Paul) über den Verkauf (Johnny) bis zur eigentlichen Weinherstellung (Peter und Charles). In
                        Tatsächlich ist Peter Symington so berühmt (das älteste Mitglied des Clans mit 42 beeindruckenden Winzern).
                        Jahre auf dem Buckel), dass er bei der International zum „Fortified Wine Maker of the Year“ gewählt wurde
                        Nicht weniger als sechs Mal nahm ich an der Wine Challenge in London teil. Unter seiner Leitung standen die Symington-Ländereien
                        brachte einige wunderbare Weine hervor, insbesondere Dow 2011, 2007, 1966, 1908, Warre Otima Tawny, LBV 1992,
                        1963, Graham 2000, 1970 und Smith Woodhouse 1977. Der beste Jahrgang aller Zeiten wäre der 1960er
                        letztes großartiges Weinjahr für Portwein. Dabei handelt es sich um Blue-Chip-Investmentweine, zum Beispiel den Dow 2011
                        Der Preis verdoppelte sich fast, nachdem es von den Kritikern sehr gute Bewertungen erhalten hatte. Ihre Quinta do Noval
                        Nacional ist seit langem ein Investitionswein, der leicht 1.000 Pfund pro Flasche kostet.
                    </div>

                    <div class="howto-title2">Zwanzig Jahre Tafelweine</div>
                    <div class="howto-text">
                        Da die Portweinverkäufe jedoch zurückgingen, musste sich die Familie Symington anderswo umsehen
                        zur Erweiterung. Hier kommt Chryseia zum Einsatz, ein roter Tafelwein, der zusammen mit dem ehemaligen Besitzer von Cos D’Estournel, Bruno, kreiert wurde
                        Idioten. Der Erfolg von Chryseia und seinem Schwester-Zweitwein Post Scriptum hat die Weine in Aufruhr versetzt
                        Symingtons Vertrauen in die Herstellung von Tafelwein und im Jahr 2018 wurden Pläne für ein 5-Millionen-Euro-Weingut bekannt gegeben.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Symington</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Le porto a toujours joué le rôle de second violon par rapport aux vins à investir, les collectionneurs préférant Bordeaux
                        et Bourgogne sur toute offre de la vallée du Douro. Mais quand il s'agit de saveur complexe et
                        une capacité de garde rentable, l'un des poids lourds les plus lourds du commerce du vin de Porto est le Symington
                        Domaines familiaux. Et tout cela grâce à une seule personne - l'Ecossais James Symington qui a navigué jusqu'à
                        Le Portugal en 1882 à seulement 19 ans avec le rêve de devenir grand dans le secteur du vin. Un fortuit
                        mariage avec une héritière du vin de Porto plus tard, et le reste appartient à l'histoire.
                    </div>

                    <div class="howto-title2">Un domaine familial depuis plus d'un siècle</div>
                    <div class="howto-text">
                        La famille Symington est une légende vivante à Port. Propriétaires de marques illustres telles que Dow, Graham, Warre, Smith Woodhouse, Quarles Harris et Quinta do Vesuvio, l'entreprise familiale est responsable de plus de 25 % de tous les vins de Porto exportés dans le monde (dont seulement 4 % sont vendus au Royaume-Uni).
                        Aujourd'hui, onze Symington (et trois générations) sont impliqués dans la gestion quotidienne de la
                        domaine, du marketing (Paul) aux ventes (Johnny) en passant par la vinification proprement dite (Peter et Charles). Dans
                        fait, si célèbre est Peter Symington (le membre le plus âgé du clan avec 42 vinifications impressionnantes
                        ans à son actif) qu'il a été élu « Vigneron fortifié de l'année » à l'International
                        Wine Challenge à Londres pas moins de six fois. Sous sa direction, les domaines Symington ont
                        produit des vins merveilleux, notamment Dow 2011, 2007, 1966, 1908, Warre Otima Tawny, LBV 1992,
                        1963, Graham 2000, 1970 et Smith Woodhouse 1977. Le meilleur millésime serait le 1960, le
                        dernière grande année viticole pour le Porto. Ce sont des vins d'investissement de premier ordre, le Dow 2011 par exemple
                        presque doublé de prix après avoir reçu des notes très élevées de la part des critiques. Leur Quinta do Noval
                        Nacional est depuis longtemps un vin d'investissement, atteignant facilement 1 000 £ la bouteille.
                    </div>

                    <div class="howto-title2">Vingt ans de vins de table</div>
                    <div class="howto-text">
                        Cependant, avec la baisse des ventes de vin de Porto, la famille Symington a dû chercher ailleurs
                        pour l'agrandissement. Entrez Chryseia, un vin de table rouge créé avec l'ancien propriétaire de Cos D'Estournel Bruno
                        Prats. Le succès de Chryseia et de sa sœur second vin Post Scriptum a galvanisé le
                        La confiance de Symington dans la fabrication de vin de table, et en 2018, des plans pour une cave de 5 millions d'euros ont été annoncés.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Symington</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Port has always played second-fiddle to investable wines, with collectors preferring Bordeaux
                        and Burgundy over any offering from the Douro Valley. But when it comes to complex flavour and
                        profitable ageability, one of the heaviest heavyweights in the Port wine trade are the Symington
                        Family Estates. And it is all thanks to one person – Scotsman James Symington who sailed to
                        Portugal in 1882 at just 19 with dreams of making it big in the wine business. One fortuitous
                        marriage to a Port wine heiress later, and the rest is history.
                    </div>

                    <div class="howto-title2">A family run estate for over a century</div>
                    <div class="howto-text">
                        The Symington family is a living legend in Port. Owners of illustrious brands such as Dow, Graham, Warre, Smith Woodhouse, Quarles Harris and Quinta do Vesuvio, the family business is responsible for over 25% of all exported Port wines worldwide (with just 4% sold in the UK).
                        Today, eleven Symingtons (and three generations) are involved in the day-to-day running of the
                        estate, from marketing (Paul) to sales (Johnny) to actual winemaking (Peter and Charles). In
                        fact, so famous is Peter Symington (the oldest member of the clan with 42 impressive winemaking
                        years under his belt) that he was voted “Fortified Wine Maker of the Year” at the International
                        Wine Challenge in London no fewer than six times. Under his helm, the Symington estates have
                        produced some wondrous wines, notably Dow 2011, 2007, 1966, 1908, Warre Otima Tawny, LBV 1992,
                        1963, Graham 2000, 1970 and Smith Woodhouse 1977. The best vintage ever would be the 1960, the
                        last great wine year for Port. These are blue chip investment wines, the 2011 Dow for example
                        almost doubling in price after it received very high scores from critics. Their Quinta do Noval
                        Nacional has long been an investment wine, easily hitting £1000 per bottle.
                    </div>

                    <div class="howto-title2">Twenty years of table wines</div>
                    <div class="howto-text">
                        However, with Port wine sales on the decline, the Symington family have had to look elsewhere
                        for expansion. Enter Chryseia, a red table wine created with ex-Cos D’Estournel owner Bruno
                        Prats. The success of Chryseia and its sister second wine Post Scriptum has galvanised the
                        Symington’s confidence in table wine making, and in 2018, plans for a €5m winery were announced.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Symington",
    data() {
        return {
            select: {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'},
            items: [
                {report: 'Casa Ferreirinha', src: '/wine-guide/portugal/douro-valley/casa-ferreirinha'},
                {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
                {
                    report: 'Prats and Symington (Chryseia)',
                    src: '/wine-guide/portugal/douro-valley/prats-and-symington'
                },
                {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
                {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
                {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
                {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
                {
                    report: 'Roquette & Cazes — Quinta do Crasto',
                    src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'
                },
                {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Symington | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the Symington family\'s commitment to excellence in winemaking, producing premium wines in the Douro Valley region of Portugal for over 130 years. Explore their unique portfolio and taste the legacy of the Symington family.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
